import { DotLottieReact, DotLottieReactProps } from '@lottiefiles/dotlottie-react';
import { useCobrand } from 'features/cobrand/hooks/useCobrandUtils';
import React from 'react';

type DotLottieProps = Omit<DotLottieReactProps, 'themeId'>;

export const DotLottie = (props: DotLottieProps) => {
  const { cobrand } = useCobrand();

  return <DotLottieReact {...props} themeId={cobrand.id} />;
};
